// * @Description: 隐患整改趋势
<template>
  <el-card class="h-full">
    <div class="flex flex-col h-full">
      <div class="text-right">
        <el-radio-group v-model="radioValue" size="mini" @input="getKpiList">
          <el-radio-button size="small" :label="0">七天</el-radio-button>
          <el-radio-button size="small" :label="1">1个月</el-radio-button>
          <el-radio-button size="small" :label="2">3个月</el-radio-button>
          <el-radio-button size="small" :label="3">1年</el-radio-button>
        </el-radio-group>
      </div>
      <KpiList :data="list"></KpiList>
      <div class="flex-auto h-0 flex">
        <div class="flex-auto w-0 flex flex-col h-full">
          <div class="flex-auto h-0px relative mb-15px border-inherit border-1 overflow-hidden">
            <div
              class="absolute left-20px top-20px flex justify-between items-center border-color-default pl-20px"
            >
              <p class="border-l-3 border-color-primary pl-10px text-18px">隐患数量变化趋势</p>
            </div>
            <v-chart
              v-loading="chartLoading"
              :options="lineOption"
              autoresize
              class="w-full h-full overflow-hidden"
            ></v-chart>
          </div>
          <div class="flex-auto h-0px relative border-inherit border-1 overflow-hidden">
            <div
              class="absolute left-20px top-20px flex justify-between items-center border-color-default pl-20px"
            >
              <p class="border-l-3 border-color-primary pl-10px text-18px">隐患整改完成率</p>
            </div>
            <v-chart
              v-loading="chartLoading"
              :options="completeOption"
              autoresize
              class="w-full h-full overflow-hidden"
            ></v-chart>
          </div>
        </div>
        <div class="h-full w-430px ml-15px shadow border-inherit border-1 overflow-y-auto px-15px">
          <Ranking :data="rankingList"></Ranking>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import { HiddenDangerStatisticsApi } from '@wiz-api/double-prevention-management'
import KpiList from '../components/KpiList'
import Ranking from '../components/Ranking'

const hiddenDangerStatisticsApi = new HiddenDangerStatisticsApi()

export default {
  name: 'rectify-trends',
  components: {
    KpiList,
    Ranking,
  },
  data() {
    return {
      chartLoading: false,
      radioValue: 0,
      list: [
        {
          label: '隐患上报',
          value: 0,
          unit: '条',
          color: '#0082ff',
        },
        {
          label: '隐患审核',
          value: 0,
          unit: '条',
          color: 'red',
        },
        {
          label: '隐患整改',
          value: 0,
          unit: '条',
          color: 'orange',
        },
        {
          label: '隐患验收',
          value: 0,
          unit: '条',
          color: 'green',
        },
      ],
      kpiList: [],
      lineChartLoading: false,
      lineOption: {
        tooltip: {
          show: true,
          trigger: 'axis',
        },
        legend: {
          show: true,
          top: 15,
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            showMaxLabel: true,
          },
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '隐患总数',
            data: [],
            type: 'line',
            smooth: true,
          },
          {
            name: '重大隐患',
            data: [],
            type: 'line',
            smooth: true,
          },
        ],
      },
      completeOption: {
        tooltip: {
          show: true,
          trigger: 'axis',
        },
        legend: {
          show: true,
          top: 15,
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            showMaxLabel: true,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
        },
        series: [
          {
            // name: '整改完成数',
            name: '整改完成率',
            data: [],
            type: 'line',
          },
        ],
      },
      rankingList: [],
    }
  },
  methods: {
    async getKpiList() {
      this.chartLoading = true
      const [err, res] =
        await hiddenDangerStatisticsApi.hiddenDangerRectificationStatisticalAnalysis({
          timeConditionEnums: this.radioValue,
        })
      if (!err) {
        this.list[0].value = res.hiddenDangerReportCount || 0
        this.list[1].value = res.hiddenDangerVerificationCount || 0
        this.list[2].value = res.hiddenDangerRectificationCount || 0
        this.list[3].value = res.investigationNormalCount || 0
        this.rankingList = res.hiddenDangerRectificationCompletedRankings.map((item) => {
          item.name = item.departmentStr
          item.value = item.checksCount
          return item
        })
        if (res.hiddenDangerQuantityChangeTrends) {
          const xData = []
          const yData1 = []
          const yData2 = []
          const option = JSON.parse(JSON.stringify(this.lineOption))
          res.hiddenDangerQuantityChangeTrends.forEach((item) => {
            xData.push(item.timeStr)
            // yData1.push(item.dailyHiddenDangersTotalCount)
            // yData2.push(item.dailyMajorHiddenDangerCount)

            yData1.push(item.hiddenDangersTotalCount)
            yData2.push(item.majorHiddenDangerCount)
          })
          option.xAxis.data = xData
          option.series[0].data = yData1
          option.series[1].data = yData2
          this.lineOption = option
        }
        if (res.hiddenDangerRectificationCompletionRates) {
          const xData = []
          const yData = []
          const rateList = []
          const option = JSON.parse(JSON.stringify(this.completeOption))
          res.hiddenDangerRectificationCompletionRates.forEach((item) => {
            xData.push(item.timeStr)
            yData.push(item.dailyAcceptancePassesCount)
            rateList.push(item.rectificationCompletionRate)
          })
          // option.tooltip.formatter = (params) => {
          //   return `${params.name}<br/>${params.marker}${params.seriesName}:${params.value}<br/>${
          //     params.marker
          //   }整改完成率:${rateList[params.dataIndex]}`
          // }
          option.xAxis.data = xData
          // option.series[0].data = yData

          option.series[0].data = rateList.map((str) => {
            return str.replace('%', '')
          })
          this.completeOption = option
        }
        this.chartLoading = false
      }
    },
  },
  mounted() {
    this.getKpiList()
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
